import React, { useState } from 'react';
import { oneOfType, arrayOf, node } from 'prop-types';

const ModalContext = React.createContext([{}, () => {}]);

const ModalContextProviderComponent = ({ children }) => {
  const [menuState, setMenuState] = useState({
    isMenuOpen: false
  });

  return (
    <ModalContext.Provider value={[menuState, setMenuState]}>{children}</ModalContext.Provider>
  );
};

ModalContextProviderComponent.propTypes = {
  children: oneOfType([arrayOf(node), node])
};

const ModalContextProvider = ModalContextProviderComponent;

export { ModalContext, ModalContextProvider };
